import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Layout from "../../page/layout";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../features/authSlice";
import { Button, Card, Container, Row, Col, Spinner } from "react-bootstrap";
import { IoAddCircle } from "react-icons/io5";

const PabrikProduksi = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);
  const [userData, setUserData] = useState([]);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");

      try {
        const response = await axios.get(
          `https://c-greenproject.org:8000/produksi`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setUserData(response.data);
      } catch (error) {
        console.error(
          "Error fetching data:",
          error.response?.status,
          error.response?.data
        );
      }
    };

    if (user?.uuid) {
      fetchData();
    }
  }, [user?.uuid]);

  return (
    <Layout>
      <Container>
        <h2 className="mb-4">
          <strong>Data Produksi Harian Pabrik</strong>
        </h2>

        {user && (user.role === "admin" || user.role === "pabrik") && (
          <Link to="/produksi/add">
            <Button variant="primary" className="mb-3">
              <IoAddCircle /> Tambah Data Produksi Harian
            </Button>
          </Link>
        )}

        {userData.length ? (
          userData.map((data, index) => (
            <Card key={index} className="mb-4 shadow-sm">
              <Card.Body>
                {/* Informasi Pabrik */}
                {user &&
                  (user.role === "admin" || user.role === "perusahaan") && (
                    <Row className="mb-3">
                      <Row>
                        <Col md={4} className="fw-bold">
                          Nama Pabrik
                        </Col>
                        <Col md={8}>{data.user.name}</Col>
                      </Row>
                      <Row>
                        <Col md={4} className="fw-bold">
                          Email Pabrik
                        </Col>
                        <Col md={8}>{data.user.email}</Col>
                      </Row>
                      <Row>
                        <Col md={4} className="fw-bold">
                          ID Produksi
                        </Col>
                        <Col md={8}>{data.idProduksiharian}</Col>
                      </Row>
                    </Row>
                  )}

                {/* Informasi Produksi */}
                <h5 className="fw-bold mt-3">1. Data Produksi</h5>
                <Row>
                  <Col md={4} className="mb-1 fw-bold text-muted">
                    ID Order
                  </Col>

                  <Col md={8}>{data.Idorderdipakai}</Col>
                </Row>
                <Row>
                  <Col md={4} className="mb-1 fw-bold text-muted">
                    Tanggal Produksi
                  </Col>
                  <Col md={8}>{data.tanggalProduksi}</Col>
                </Row>
                <Row>
                  <Col md={4} className="mb-1 fw-bold text-muted">
                    Jenis Olahan
                  </Col>
                  <Col md={8}>{data.Jenisolahan}</Col>
                </Row>
                <Row>
                  <Col md={4} className="mb-1 fw-bold text-muted">
                    Jumlah Produksi Harian
                  </Col>
                  <Col md={8}>{data.jumlahproduksiharian}</Col>
                </Row>
                <Row>
                  <Col md={4} className="mb-1 fw-bold text-muted">
                    Kualitas Output
                  </Col>
                  <Col md={8}>{data.kualitasOutput}</Col>
                </Row>

                <h5 className="fw-bold mt-3">2. Data Operasional </h5>
                <Row>
                  <Col md={4} className="mb-1 fw-bold text-muted">
                    Permasalahan Operasional
                  </Col>
                  <Col md={8}>{data.permasalahanOperasional}</Col>
                </Row>
                <Row>
                  <Col md={4} className="mb-1 fw-bold text-muted">
                    Kebutuan Perbaikan
                  </Col>
                  <Col md={8}>{data.kebutuhanPerbaikan}</Col>
                </Row>

                <h5 className="fw-bold mt-3">3. Data Limbah</h5>
                <Row>
                  <Col md={4} className="mb-1 fw-bold text-muted">
                    Limbah Cair
                  </Col>
                  <Col md={8}>{data.limbahcair}</Col>
                </Row>
                <Row>
                  <Col md={4} className="mb-1 fw-bold text-muted">
                    Catatan Limbah Cair
                  </Col>
                  <Col md={8}>{data.catatanlimbah}</Col>
                </Row>
                <Row>
                  <Col md={4} className="mb-1 fw-bold text-muted">
                    Limbah Padat
                  </Col>
                  <Col md={8}>{data.limbahpadat}</Col>
                </Row>
                <Row>
                  <Col md={4} className="mb-1 fw-bold text-muted">
                    Catatan Limbah Padat
                  </Col>
                  <Col md={8}>{data.catatanlimbahpadat}</Col>
                </Row>
              </Card.Body>
            </Card>
          ))
        ) : (
          <div className="text-center">
            <Spinner animation="border" variant="primary" />
            <p>Memuat data...</p>
          </div>
        )}
      </Container>
    </Layout>
  );
};

export default PabrikProduksi;
